import AnalyticsEngineGTMBase from "../../../../src/common/analytics/engines/analyticsEngineGTMBase";

export default class AnalyticsEngineGTM extends AnalyticsEngineGTMBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
  }
}



// WEBPACK FOOTER //
// ./clients/tec-ldh/js/engines/analyticsEngineGTM.js